import {ApiLoggingAdapterInterface} from './utility/api-logging-adapter-interface';
import {ApiMetricsAdapterInterface} from './utility/api-metrics-adapter-interface';
import {JsonRpcRequestWrapper} from './json-rpc-request-wrapper';

export class BaseApiWrapper {
    protected loggingAdapter?: ApiLoggingAdapterInterface;
    protected metricsAdapter?: ApiMetricsAdapterInterface;

    public setLoggingAdapter(adapter: ApiLoggingAdapterInterface) {
        this.loggingAdapter = adapter;
    }

    public setMetricsAdapter(adapter: ApiMetricsAdapterInterface) {
        this.metricsAdapter = adapter;
    }

    public setCmdAdapters(cmd: JsonRpcRequestWrapper<any, any>): void {
        if (this.loggingAdapter) {
            cmd.setLoggingAdapter(this.loggingAdapter);
        }
        if (this.metricsAdapter) {
            cmd.setMetricsAdapter(this.metricsAdapter);
        }
    }
}